
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
    deleteBookmark
} from '../../../redux/user/userActions'
//MUI
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Rating from '@material-ui/lab/Rating';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
//Components
import * as globalFuncs from '../../../globalFuncs/Entities/Product/Index'

const useStyles = makeStyles((theme) => ({
    btn: {
        backgroundColor: '#28A504',
        fontWeight: '700',
        '&:hover': {
            backgroundColor: "#417557",
        },
    },
    btnRemoveBookmark: {
        minWidth: '35px',
        backgroundColor: "transparent",
        boxShadow: 'none !important',
        border: 'none',
        '&:hover': {
            backgroundColor: "transparent",
        },
        '&:focus': {
            backgroundColor: "transparent",
        },
    },
    paperNoBg: {
        backgroundColor: 'transparent',
    },
}));

const ProductBox = ({ product, lang, dbid }) => {
    const removeBookmarkStatus = useSelector(state => state.removeBookmark)
    const classes = useStyles();
    const dispatch = useDispatch()
    const [msgShow, setMsgShow] = useState(false)
    const [sending, setSending] = useState(false)
    const [bookmarkedID, setBookmarkedID] = useState(0)

    useEffect(() => {
        if (typeof removeBookmarkStatus !== "undefined" && !msgShow) {
            if (removeBookmarkStatus.message !== '') {
                if (removeBookmarkStatus.message !== '') {
                    setMsgShow(true)
                    setSending(false)
                }
            }
        }
    }, [dispatch, removeBookmarkStatus, setMsgShow])

    const handleRemoveBookmark = (bid) => {
        if (typeof localStorage.getItem("token") !== 'undefined' && localStorage.getItem("token") !== null && localStorage.getItem("token") !== '') {
            dispatch(deleteBookmark(bid))
            setBookmarkedID(bid.toString())
            setSending(true)
        }
    }

    return (
        (product !== null) && (
            <Grid item md={3} xs={6} spacing={1} style={{ display: (msgShow && bookmarkedID === product.id.toString()) ? 'none' : 'block' }}>
                <Paper
                    elevation={0}
                    className={
                        classes.paperNoBg + " productsList"
                    }>
                    <Box
                        elevation={1}
                        boxShadow={0}
                        border={0}
                        p={{ md: 1, lg: 1, xs: 0 }}
                        m={{ md: 1, lg: 1, xs: 0 }}>
                        <div dir="rtl" className="product">
                            <div className="image">
                                <Link to={`/product/${product.id}`}>
                                    <img alt="" src={product.imgURL} />
                                </Link>
                            </div>
                            <div className="content">
                                <Link to={`/product/${product.id}`}>
                                    <h3>{product.title}</h3>
                                </Link>
                                <p className="price">{globalFuncs.SepratePrice(product.price250, lang)}</p>
                                <div style={{ textAlign: 'center' }}>
                                    <Rating
                                        name="simple-controlled2"
                                        value={product.starRating}
                                        disabled
                                    />
                                </div>
                                <div className="productBoxBottomArea">
                                    <div className="IconArea">
                                        <Button className={classes.btnRemoveBookmark} disabled={sending} onClick={() => { handleRemoveBookmark(`${product.id}`) }}><DeleteForeverIcon /></Button>
                                    </div>
                                    <div className="btnArea">
                                        <Link to={`/product/${product.id}`}>
                                            <Button variant="contained" color="primary" className={classes.btn + ' sbBtn'}>
                                                جزئیات محصول
                                        </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Box>

                </Paper>
            </Grid>
        )
    )
}

export default ProductBox
